import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NavItem } from '@app/layouts/parametria-layout/nav.item';
import { environment } from 'src/environments/environment';
import { MenuItem as PrimeMenuItem } from 'primeng/api';
import { ModulosService } from '@pages/modules-permission/services/modulos.service';
import { MicrosoftAuthService } from '@pages/authentication/services/microsoft-auth.service';

interface CustomMenuItem {
  icon: string;
  label: string;
  route?: string;
  children?: CustomMenuItem[];
  isActive?: boolean;
  isExpanded?: boolean;
  moduleId?: number;
  items?: PrimeMenuItem[];
  url?: string;
  command?: () => void;
}

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.css'],
  animations: [
    trigger('submenuAnimation', [
      state(
        'collapsed',
        style({
          height: '0',
          opacity: '0'
        })
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: '1',
        })
      ),
      transition('collapsed <=> expanded', [animate('200ms ease-in-out')])
    ])
  ]
})
export class AsideComponent implements OnInit {
  @Input() isExpanded = false;

  version = environment.version;
  items: any[] = [];
  itemsMobile: PrimeMenuItem[] = [];
  navItems: NavItem[];
  jsonModules: any;
  usser: string;
  shouldRun: boolean = true;

  menuItems: CustomMenuItem[] = [
    {
      icon: 'home',
      label: 'Inicio',
      route: '/home'
    },
    {
      icon: 'people',
      label: 'Clientes',
      children: [
        {
          icon: 'person_add',
          label: 'ABC Clientes',
          route: '/fabrica-credito/abc-clientes'
        },
        {
          icon: 'assignment',
          label: 'Solicitudes',
          route: '/fabrica-credito/solicitudes'
        }
      ]
    },
    {
      icon: 'settings',
      label: 'Configuración',
      children: [
        {
          icon: 'admin_panel_settings',
          label: 'Permisos',
          route: '/modules-permission'
        },
        {
          icon: 'manage_accounts',
          label: 'Usuarios',
          route: '/users'
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private modulosService: ModulosService,
    private microsoftAuthService: MicrosoftAuthService
  ) {}

  ngOnInit(): void {
    this.jsonModules = JSON.parse(sessionStorage.getItem('Modules'));
    this.usser = JSON.parse(sessionStorage.getItem('Usser'));
    this.navItems = this.jsonModules;
    
    this.items = this.convertNavItemsToMenuItems(this.navItems);
    this.itemsMobile = this.convertNavItemsToMenuItemsMobile(this.navItems);
    this.LoadSubMenu();
    this.setActiveRoute(this.router.url);
  }

  LoadSubMenu() {
    const UserEmail: string = JSON.parse(sessionStorage.getItem('Usser'));
    this.navItems.forEach((menuPrincipal) => {
      this.modulosService.SpGetSubMenusByRolID(UserEmail, menuPrincipal.moduleId).subscribe(
        (response) => {
          // console.log(
          //   `Submenús para moduleId ${menuPrincipal.moduleId}:`,
          //   response.data.result
          // );
          const subMenu = response.data.result;
          this.assignSubMenusToMainMenu(menuPrincipal.moduleId, subMenu);
        },
        (error) => {
          console.error(`Error al obtener los submódulos para moduleId ${menuPrincipal.moduleId}:`, error);
        }
      );
    });
  }

  assignSubMenusToMainMenu(moduleId: number, subMenu: any[]) {
    const mainMenuItem = this.navItems.find((item) => item.moduleId === moduleId);

    if (mainMenuItem) {
      const parentMenus = subMenu.filter((sub) => !sub.ParentId || !subMenu.some((s) => s.MenuId === sub.ParentId));

      if (mainMenuItem.children) {
        mainMenuItem.children = [
          ...mainMenuItem.children,
          ...parentMenus.map((subItem) => ({
            displayName: subItem.MenuName.trim(),
            url: subItem.UrlMenu && subItem.UrlMenu.trim() !== '' ? subItem.UrlMenu : subItem.UrlModule,
            moduleId: subItem.MenuId,
            iconName: subItem.Icon,
            children: subMenu
              .filter((opcion) => opcion.ParentId === subItem.MenuId)
              .map((opcion) => ({
                displayName: opcion.MenuName.trim(),
                url: opcion.UrlMenu,
                moduleId: opcion.MenuId,
                iconName: opcion.Icon
              }))
          }))
        ];
      } else {
        mainMenuItem.children = parentMenus.map((subItem) => ({
          displayName: subItem.MenuName.trim(),
          url: subItem.UrlMenu && subItem.UrlMenu.trim() !== '' ? subItem.UrlMenu : subItem.UrlModule,
          moduleId: subItem.MenuId,
          iconName: subItem.Icon,
          children: subMenu
            .filter((opcion) => opcion.ParentId === subItem.MenuId)
            .map((opcion) => ({
              displayName: opcion.MenuName.trim(),
              url: opcion.UrlMenu,
              moduleId: opcion.MenuId,
              iconName: opcion.Icon
            }))
        }));
      }

      //   console.log(
      //     `Menú principal actualizado para moduleId ${moduleId}:`,
      //     mainMenuItem
      //   );
    }

    this.items = this.convertNavItemsToMenuItems(this.navItems);
    this.itemsMobile = this.convertNavItemsToMenuItemsMobile(this.navItems);
  }

  convertNavItemsToMenuItems(navItems: NavItem[]): CustomMenuItem[] {
    return navItems
      .map((item) => {
        if (!item.displayName) return null;

        const validChildren = item.children ? item.children.filter((child) => child.displayName) : [];

        const menuItem = {
          label: item.displayName,
          icon: this.getIcon(item.displayName),
          url: item.url,
          moduleId: item.moduleId,
          items: validChildren.length > 0 ? this.convertNavItemsToMenuItems(validChildren) : undefined,
          horizontal: validChildren.length >= 6
        };

        if (!menuItem.items || menuItem.items.length === 0) {
          delete menuItem.items;
        }

        return menuItem;
      })
      .filter((item) => item !== null);
  }

  convertNavItemsToMenuItemsMobile(navItems: NavItem[]): PrimeMenuItem[] {
    return navItems
      .map((item) => {
        if (!item.displayName) return null;

        const validChildren = item.children ? item.children.filter((child) => child.displayName) : [];

        const menuItem: PrimeMenuItem = {
          label: item.displayName,
          icon: this.getIcon(item.displayName),
          command: validChildren.length === 0 ? () => this.GoTo(item) : undefined,
          items: validChildren.length > 0 ? this.convertNavItemsToMenuItemsMobile(validChildren) : undefined
        };

        return menuItem;
      })
      .filter((item) => item !== null) as PrimeMenuItem[];
  }

  goToHome() {
    this.router.navigate(['index']);
  }

  logout() {
    const isMicrosoft = this.microsoftAuthService.logout();
    if (!isMicrosoft) {
      this.router.navigate(['sign-in']);
    }
  }

  GoTo(menu: any) {
    // Si es móvil y el menú tiene hijos, no redirijas
    if (!this.isLargeScreen() && menu.items && menu.items.length > 0) {
      return; // No hacer nada si es un menú padre en móvil
    }
    if (menu.moduleId) {
      switch (menu.moduleId.toString()) {
        case '10':
          this.router.navigate(['cobranzas']);
          return;
        case '4':
          this.router.navigate(['plan-pagos']);
          return;
        case '3':
          this.router.navigate(['fabrica-credito']);
          return;
      }
    }
    if (menu.url) {
      this.router.navigate([menu.url]);
    } else {
      console.warn(`No se definió una ruta para el menú: ${menu.label}`);
    }
  }

  getIcon(name: string) {
    switch (name) {
      case 'Parametria':
        return 'pi pi-cog';
      case 'Originación de Crédito':
        return 'pi pi-briefcase';
        case 'Originación':
        return 'pi pi-briefcase';
      case 'Adminstración de Cartera':
        return 'pi pi-book';
        case 'Adminstración':
        return 'pi pi-book';
      case 'Recuperación Cartera':
        return 'pi pi-money-bill';
        case 'Recuperación':
        return 'pi pi-money-bill';
      case 'Usuarios':
        return 'pi pi-users';
      case 'Rol':
        return 'pi pi-user-edit';
      case 'Permisos Rol':
        return 'pi pi-wrench';
      case 'Permisos Formularios':
        return 'pi pi-file-check';
      case 'Control Usuarios':
        return 'pi pi-user-plus';
      case 'Solicitudes':
        return 'pi pi-send';
      case 'Portafolio':
        return 'pi pi-briefcase';
      case 'Mantenimiento':
        return 'pi pi-wrench';
      case 'Parametros':
        return 'pi pi-cog';
      case 'ABC Perfiles Optimos':
        return 'pi pi-check';
      case 'Tipos de Créditos':
        return 'pi pi-credit-card';
      case 'ABC Motivos':
        return 'pi pi-book';
      case 'ABC Empresas':
        return 'pi pi-building';
      case 'Parametros Variables':
        return 'pi pi-chart-line';
      case 'ABC Tasas':
        return 'pi pi-database';
      case 'ABC Tipos de Cartera':
        return 'pi pi-wallet';
      case 'ABC Nominaciones':
        return 'pi pi-graduation-cap';
      case 'ABC Estatus/SubEstatus':
        return 'pi pi-check-square';
      case 'ABC Formas de Pago':
        return 'pi pi-dollar';
      case 'ABC Promociones':
        return 'pi pi-percentage';
      case 'ABC Conceptos':
        return 'pi pi-list-check';
      case 'ABC Movimientos Caja':
        return 'pi pi-box';
      case 'ABC Estatus Legal':
        return 'pi pi-shield';
      case 'Libranzas':
        return 'pi pi-credit-card';
      case 'Libranza Actual':
        return 'pi pi-objects-column';
      case 'Libranza Nueva':
        return 'pi pi-hammer';
      // Iconos para menús faltantes identificados en los logs
      case 'Consulta de Log':
        return 'pi pi-list';
      case 'Ruta Crítica':
        return 'pi pi-map';
      case 'Investigaciones':
        return 'pi pi-search';
      case 'ABC Acciones':
        return 'pi pi-cog';
      case 'ABC Resultados':
        return 'pi pi-chart-bar';
      case 'ABC Lineas':
        return 'pi pi-list';
      case 'ABC Articulos':
        return 'pi pi-shopping-cart';
      case 'ABC Bancos':
        return 'pi pi-building';
      case 'ABC Sectores':
        return 'pi pi-sitemap';
      case 'ABC Monedas':
        return 'pi pi-money-bill';
      case 'ABC Campos Customizables':
        return 'pi pi-sliders-h';
      case 'ABC Pantallas Customizables':
        return 'pi pi-desktop';
      case 'ABC Catalogo Campos Customizables':
        return 'pi pi-book';
      case 'Parametros Generales':
        return 'pi pi-cog';
      case 'ABC Lista Empresas':
        return 'pi pi-building';
      case 'ABC Lista Personas':
        return 'pi pi-users';
      case 'ABC Lista Teléfonos':
        return 'pi pi-phone';
      case 'Capturista':
        return 'pi pi-user-edit';
      case 'Analista':
        return 'pi pi-user';
      case 'Gestor':
        return 'pi pi-user-plus';
      case 'Canal llegada':
        return 'pi pi-sign-in';
      case 'Vendedores':
        return 'pi pi-shopping-bag';
      case 'Destinos':
        return 'pi pi-map-marker';
      case 'Paridades':
        return 'pi pi-refresh';
      case 'Paises':
        return 'pi pi-globe';
      case 'Zonas/Ciudades':
        return 'pi pi-map';
      case 'Variables Financieras':
        return 'pi pi-calculator';
      case 'Documentos':
        return 'pi pi-file';
      case 'Checklist':
        return 'pi pi-check-circle';
      case 'Titulos':
        return 'pi pi-tag';
      case 'Giros':
        return 'pi pi-send';
      // Iconos para submódulos de Recuperación Cartera
      case 'Clientes':
        return 'pi pi-users';
      case 'Busqueda de clientes':
        return 'pi pi-search';
      case 'Atención de alarmas':
        return 'pi pi-bell';
      case 'Atencion de agendas':
        return 'pi pi-calendar';
      case 'Supervisión':
        return 'pi pi-eye';
      case 'Asignación':
        return 'pi pi-user-plus';
      case 'Reportes':
        return 'pi pi-chart-bar';
      case 'Asignación Masiva':
        return 'pi pi-users';
      // Iconos para submódulos de Administración de Cartera (Plan de Pagos)
      case 'Cesiones':
        return 'pi pi-file-export';
      case 'Consulta general de cartera':
        return 'pi pi-search';
      case 'Pagos':
        return 'pi pi-dollar';
      case 'Masivos':
        return 'pi pi-users';
      case 'Resumen Polizas':
        return 'pi pi-file';
      case 'Contabilidad':
        return 'pi pi-calculator';
      case 'Renegociaciones de créditos':
        return 'pi pi-refresh';
      case 'Pagos fuera de fecha':
        return 'pi pi-clock';
      case 'Reestructuración de créditos':
        return 'pi pi-wrench';
      case 'Aplicación de cargos y abonos':
        return 'pi pi-plus-circle';
      case 'Captura masiva pagos':
        return 'pi pi-upload';
      case 'Movimientos Caja':
        return 'pi pi-box';
      case 'Reintegro de operaciones':
        return 'pi pi-undo';
      case 'Cancelacion de créditos':
        return 'pi pi-times-circle';
      case 'Reverso Pagos':
        return 'pi pi-arrow-left';
      case 'Factoraje':
        return 'pi pi-chart-line';
      case 'Traspaso operaciones':
        return 'pi pi-arrows-h';
      case 'Resumen de pagos':
        return 'pi pi-chart-bar';
      case 'Pagos en suspenso':
        return 'pi pi-pause';
      case 'Interfase Contable':
        return 'pi pi-database';
      // Iconos para submódulos de Originación de Crédito (Fábrica de Crédito)
      case 'Solicitudes/Clientes':
        return 'pi pi-users';
      case 'Alta rapida personas':
        return 'pi pi-user-plus';
      case 'Alta rapida empresas':
        return 'pi pi-building';
      case 'ABC Clientes y solicitudes':
        return 'pi pi-cog';
      case 'Reporte Ejecutivo':
        return 'pi pi-chart-pie';
      case 'Investigaciones':
        return 'pi pi-search';
      case 'Resumen de Consultas al Buró':
        return 'pi pi-chart-bar';
      case 'MIS':
        return 'pi pi-th-large';
      case 'Listado de Consultas al Buró':
        return 'pi pi-list';
      case 'Investigaciones por gestor':
        return 'pi pi-user-edit';
      case 'Colas de trabajo':
        return 'pi pi-clock';
      default:
        return 'pi pi-chevron-circle-right';
    }
  }

  isLargeScreen(): boolean {
    return window.innerWidth > 768;
  }

  /**
   * Detecta cuando un submenú (subhijos) toca el borde inferior y ajusta su posición
   * Solo aplica a subhijos (segundo y tercer nivel), no a hijos principales
   */
  onSubmenuMouseEnter(event: MouseEvent, isSubChild: boolean = false): void {
    // Solo aplicar a subhijos (segundo y tercer nivel)
    if (!isSubChild) return;

    const targetElement = event.currentTarget as HTMLElement;
    const submenuElement = targetElement.querySelector('ul') as HTMLElement;
    
    if (!submenuElement) return;

    // Esperar a que el submenú se muestre (con :hover) antes de calcular
    // Usar requestAnimationFrame múltiple para asegurar que el DOM esté actualizado
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.adjustSubmenuPosition(submenuElement, targetElement);
      });
    });
  }

  /**
   * Ajusta la posición del submenú para que no se salga por arriba o abajo
   * Opciones: expandir hacia arriba o centrar verticalmente
   */
  private adjustSubmenuPosition(submenuElement: HTMLElement, parentElement: HTMLElement): void {
    // Resetear clases previas
    submenuElement.classList.remove('submenu-up', 'submenu-centered');
    
    // Verificar si el submenú está visible (display != none)
    const computedStyle = window.getComputedStyle(submenuElement);
    if (computedStyle.display === 'none') {
      return; // El submenú aún no se ha mostrado
    }
    
    // Obtener las dimensiones reales del submenú
    const submenuRect = submenuElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const parentRect = parentElement.getBoundingClientRect();
    
    // Calcular espacios disponibles
    const spaceBelow = viewportHeight - submenuRect.bottom;
    const spaceAbove = parentRect.top;
    const submenuHeight = submenuRect.height;
    
    // Detectar si el submenú se sale por arriba o por abajo
    const overflowsBottom = spaceBelow < 20;
    const overflowsTop = submenuRect.top < 20;
    
    // Si se sale por arriba O por abajo, centrar siempre
    if (overflowsTop || overflowsBottom) {
      // Verificar si al centrar también se saldría
      const centerPosition = parentRect.top + (parentRect.height / 2);
      const centeredTop = centerPosition - (submenuHeight / 2);
      const centeredBottom = centerPosition + (submenuHeight / 2);
      
      // Si al centrar no se sale por ningún lado, centrar
      if (centeredTop >= 20 && centeredBottom <= viewportHeight - 20) {
        submenuElement.classList.add('submenu-centered');
      } else if (overflowsTop && spaceAbove < submenuHeight) {
        // Si se sale por arriba y no hay espacio, centrar de todas formas
        submenuElement.classList.add('submenu-centered');
      } else if (overflowsBottom && spaceAbove > submenuHeight + 50) {
        // Si se sale por abajo pero hay espacio arriba, expandir hacia arriba
        submenuElement.classList.add('submenu-up');
      } else {
        // En cualquier otro caso, centrar
        submenuElement.classList.add('submenu-centered');
      }
    }
  }

  toggleSubmenu(item: CustomMenuItem): void {
    if (item.children) {
      item.isExpanded = !item.isExpanded;
    } else {
      this.navigateTo(item.route);
    }
  }

  navigateTo(route: string): void {
    if (route) {
      this.router.navigate([route]);
      this.setActiveRoute(route);
    }
  }

  private setActiveRoute(route: string): void {
    this.menuItems.forEach((item) => {
      if (item.children) {
        item.children.forEach((child) => {
          child.isActive = child.route === route;
          if (child.isActive) {
            item.isExpanded = true;
          }
        });
      } else {
        item.isActive = item.route === route;
      }
    });
  }
}
